import { render, staticRenderFns } from "./BrotherCard.vue?vue&type=template&id=286e99cc&scoped=true&"
import script from "./BrotherCard.vue?vue&type=script&lang=js&"
export * from "./BrotherCard.vue?vue&type=script&lang=js&"
import style0 from "./BrotherCard.vue?vue&type=style&index=0&id=286e99cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286e99cc",
  null
  
)

export default component.exports